import { render, staticRenderFns } from "./SearchResultModal.vue?vue&type=template&id=345f6768&scoped=true&"
import script from "./SearchResultModal.vue?vue&type=script&lang=ts&"
export * from "./SearchResultModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f6768",
  null
  
)

export default component.exports